import { render, staticRenderFns } from "./ProviderItems.vue?vue&type=template&id=524dcd16"
import script from "./ProviderItems.vue?vue&type=script&lang=js"
export * from "./ProviderItems.vue?vue&type=script&lang=js"
import style0 from "./ProviderItems.vue?vue&type=style&index=0&id=524dcd16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports